<template>
	<div>
		<b-container fluid>
			<b-form @submit="onSubmit">

				<input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
<b-form-group label="Code">
      <b-form-input
          type="text"
          id="dataItem-code-input"
          class="form-input"
          v-model="dataItem.code"
          @blur="$v.dataItem.code.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.code.required">Code is required</div>
      </div>
      </b-form-group>
<b-form-group label="Description">
      <b-form-input
          type="text"
          id="dataItem-description-input"
          class="form-input"
          v-model="dataItem.description"
          @blur="$v.dataItem.description.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.description.required">Description is required</div>
      </div>
      </b-form-group>
<b-form-group label="Active">
  <b-form-checkbox
    id="dataItem-active-input"
    class="form-input"
    v-model="dataItem.active">Active
    </b-form-checkbox>
  </b-form-group>


				<b-row>
					<b-col md="6">
						<label>Created</label>
					</b-col>
					<b-col md="6">
						<label>Modified</label>
					</b-col>
				</b-row>

				<b-button
					type="submit"
					variant="primary"
					style="margin: 5px;"
				>Save</b-button>
				<b-button
					style="margin: 5px;"
					@click="cancel"
				>Cancel</b-button>
			</b-form>
		</b-container>

	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { dataItemDto, dataItem } from '../../dto';

export default {
  name: 'Addncmcode',
  components: {

  },
  data: () => ({
    dataItem: dataItem,

  }),
  methods:{
    async onSubmit(e) {
      e.preventDefault();

      this.$v.dataItem.$touch();
      if (this.$v.dataItem.$invalid) {
        return;
      }

      let payload = new dataItemDto(this.dataItem);
      payload.id = 0; //New records will start with an id of zero
      payload.active = true; //New records will always be true

      try {
        const id = await service.create(payload);
        this.redirectToListing();
      } catch {}
    },
    cancel(){
      this.redirectToListing();
    },
    redirectToListing() {
      this.$router.push({ name: 'ncmcodes' });
    },
  },
  validations: {
    dataItem: {

      id:{
      },
      code:{
      },
      description:{
      },
      createdByUserId:{
      },
      modifiedByUserId:{
      },
      dateCreated:{
      },
      dateModified:{
      },
      active:{
      },
    },
  },
};
</script>
